import { createSlice } from '@reduxjs/toolkit';
import InsightsUseCase from './insightsUseCase';

// Initial state for search results
const initialState = {
    insightsFeedback: []
}

const insightsReducer = createSlice({
    name: 'insightsFeedback',
    initialState,
    reducers: {
        setInsightsFeedbackFlag(state, action) {
            state.insightsFeedback = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(InsightsUseCase.captureInsightsFeedback.fulfilled, (state, action)=>{
            state.insightsFeedback = action.payload.response[0];
        })
    }
});

export const {
    setInsightsFeedbackFlag
} = insightsReducer.actions;

export default insightsReducer.reducer;